export default __webpack_public_path__ + "static/media/Q4_3.2dc213dc.jpg";